import { render } from "./FolderElement.vue?vue&type=template&id=7843a058&scoped=true"
import script from "./FolderElement.vue?vue&type=script&lang=js"
export * from "./FolderElement.vue?vue&type=script&lang=js"

import "./FolderElement.vue?vue&type=style&index=0&id=7843a058&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7843a058"]])

export default __exports__